import { DecimalPipe, LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, model, OnChanges, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NULL_METRIC_SIGN } from '@app/configurations';
import { Currency } from '@app/core/models/customer.models';
import { getLocaleFormattedNumber } from '@app/core/services/utilities.service';
import { UserState } from '@app/core/store/states/user/user.state';
import { CurrencySymbolPipe } from '@app/shared/pipes/currency-symbol.pipe';
import { select } from '@ngxs/store';
import { NzStatus } from 'ng-zorro-antd/core/types';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'adspt-currency-input',
  templateUrl: './currency-input.component.html',
  styleUrls: ['./currency-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzInputModule, FormsModule, CurrencySymbolPipe, LowerCasePipe, DecimalPipe],
})
export class CurrencyInputComponent implements OnChanges {
  readonly locale = select(UserState.userLocale);

  readonly value = model<number | string>();

  readonly currency = input<Currency>();
  readonly placeholder = input('1.01');
  readonly disabled = input();
  readonly limits = input<{ min: number; max: number }>();
  readonly valueChange = output<number | string>();

  readonly input = signal<number | string>(null);
  readonly displayInput = computed<number | string>(() => (this.input() === NULL_METRIC_SIGN ? '' : this.input()));

  readonly status = computed<NzStatus | null>(() => {
    const val = this.input();
    const { min, max } = this.limits() || {};

    if (!isNaN(+val) && min && max && (min > +val || max < +val)) {
      return 'error';
    } else {
      return null;
    }
  });

  emit(val: string) {
    this.input.set(getLocaleFormattedNumber(val));

    this.valueChange.emit(this.input());
  }

  ngOnChanges(): void {
    this.input.set(this.value() == null ? NULL_METRIC_SIGN : this.value());

    if (this.input() !== this.value()) {
      this.valueChange.emit(this.input());
    }
  }
}
